import BasePropertyView from 'BasePropertyView.js';
import { Model } from 'backbone';
import sequenceService from 'SequenceService'
import Template from 'workflow/properties/main/path.ejs';
import formulaModal from 'common-views/MainFormulaModalView.js';
import selectFieldModal from 'common-views/SelectFieldModalView';

class PathView extends BasePropertyView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]'     : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[name=pathType]' : 'updateRadioAttributes',
            'click #Formula'              : 'showFormulaModal',
            'click #ValueOfAFieldButton'  : 'showValueFieldModal',
            'change #PathConditionOperator' : 'updateAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );

        this.setParameterValue();
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        const attributes = {formulaParameter: this.model.get('formulaParameter')};

        var sfModal = new formulaModal({model: new Model(attributes), config: {selected: ''}});
        sfModal.render().then((formulaParameter)=>{
            //  Also change the creation of the modal passing the appropiated value on the config
            this.model.set('formulaParameter', formulaParameter, {silent: true});
        }).catch(err => console.log(err));
    }

    showValueFieldModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';

        var sfModal = new selectFieldModal({model: new Model()});
        sfModal.render().then((selectedField)=>{
            this.model.set('ValueOfAFieldId', selectedField.id, {silent:true});
            this.model.set('ValueOfAField', selectedField.name);

            //set parameter values.
            this.setParameterValue();

        });
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );

        this.resetFields();
        $('#'+propVal).attr('disabled', false);
        //$('#'+propVal).attr('readOnly', false);
        if (propVal === 'TextOrNumber') {
            $('#ValueOfAFieldButton').attr('disabled', false);
            $('#ConditionalValue').attr('disabled', false);
            $('#PathConditionOperator').attr('disabled', false);
        }

        this.model.set('parameters', [], {silent: true});


        $("input[name="+propName+"][value=" + propVal + "]").prop('checked', true);
    }

    resetFields() {
        $('#TextOrNumber').attr('disabled', true);
        //$('#TextOrNumber').attr('readOnly', true);
        $('#PathConditionOperator').attr('disabled', true);
        //$('#ValueOfAField').attr('readOnly', true);
        $('#ValueOfAFieldButton').attr('disabled', true);
        $('#ConditionalValue').attr('disabled', true);
        //$('#Special').attr('readOnly', true);
        $('#Formula').attr('disabled', true);
    }

    setParameterValue() {
        // building this out to match XML requirements when saving.

        var parm = {
            id:'default',
            type:'expression',
            literal: 'null',
            field: 'null',
            special: 'null',
            expression: {
                id: sequenceService.nextDomId(),
                type: 'scriptingCondition'
            }
        };

        var args = [];

        // if text or number is selected, build the expression contents
        args.push({
            kind: 'Argument',
            id: sequenceService.nextDomId(),
            type: 'scripting_formField',
            value: this.model.get('ValueOfAFieldId')
        });

        //check operator
        var op = $('#PathConditionOperator').val();
        if (op === 'checked' || op === 'notchecked') {
            args.push({
                kind: 'Operator',
                id: sequenceService.nextDomId(),
                type: '=='
            });

            args.push({
                kind: 'Argument',
                id: sequenceService.nextDomId(),
                type: 'scripting_boolean',
                value: (op === 'checked') ? 'true' : 'false'
            });
        } else {
            args.push({
                kind: 'Operator',
                id: sequenceService.nextDomId(),
                type: op
            });

            args.push({
                kind: 'Argument',
                id: sequenceService.nextDomId(),
                type: 'scripting_literal',
                value: $('#ConditionalValue').val()
            });

        }


        parm.expression.arguments = args;

        // if Formula is selected, get contents from model.


        this.model.set('parameters', parm, {silent: true});

    }

    render() {

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var option=  this.model.get('pathType');
        if (this.model.get('pathType')) {
            $("input[name=pathType][value=" + option + "]").prop('checked', true);
            $('#'+option).attr('disabled', false);
            //$('#'+option).attr('readOnly', false);
            if (option === 'TextOrNumber') {
                $('#ValueOfAFieldButton').attr('disabled', false);
                $('#ConditionalValue').attr('disabled', false);
                $('#PathConditionOperator').attr('disabled', false);
            }
        }


        if (this.model.get('PathConditionOperator')) {
            $('#PathConditionOperator').find('option[value='+this.model.get('PathConditionOperator')+']').attr('selected', true);
        }

        this.delegateEvents();
        return this;
    }

}

export default PathView;
